import React, { useEffect, useState } from "react";
import "./Hero.scss";
import { Link, useHistory } from "react-router-dom";
import useAmplifyAuth from "../../../helpers/useAmplifyAuth";
import { useTranslation } from "react-i18next";
import Modal from "../Modal/Modal";

const Hero = (props) => {
  const { handleSignout } = useAmplifyAuth();
  const { autoOpen = false, removeTagDescriptionP = false } = props;
  const [helpPopupVisible, setHelpPopupVisible] = useState(false);

  const { t } = useTranslation();
  const isCondominiumAdmin = window.location.pathname.includes("/condominium-admin");
  const isRegister = window.location.pathname.includes("/register");
  const isForgotPassword = window.location.pathname.includes("/forgot-password");
  const isBackPages = isRegister || isForgotPassword;

  useEffect(() => {
    if (autoOpen) {
      setHelpPopupVisible(true);
    }
  }, [autoOpen]);

  const helpPopupVisibleHandle = () => {
    setHelpPopupVisible(false);
  };
  return (
    <section className={!props.isLogin ? 'banner-with-text-component' : 'heroLogin hero--level-2'} data-testid={"Hero"}>
      {!props.isLogin ? (
        <div className="hero gallery-component hero-banner-version gallery--swiper single-slide hero-banner-with-text">
          {props.backTo ? (
            <section>
              <nav className="breadcrumb-nav">
                <ol className="breadcrumb">
                  {props.doLogout || props.backTo === "/logout" ? (
                    <li className="breadcrumb-item paragraph-small-fs9 font-color-1">
                      <Link
                        to={"/logout"}
                        onClick={handleSignout}
                        className="font-bold text-md-16"
                      >
                        {props.backToText || props.backTo}
                      </Link>
                    </li>
                  ) : props.inHome ? (
                    <li className="breadcrumb-item paragraph-small-fs9 font-color-1 active">
                      {props.backToText || props.backTo}
                    </li>
                  ) : isCondominiumAdmin ? (
                    <>
                      <li className="breadcrumb-item paragraph-small-fs9 font-color-1">
                        <Link
                          to={props.backHome || "/dashboard"}
                          className="breadcrumb-item paragraph-small-fs9 font-color-1"
                        >
                          {t("common.back.home")}
                        </Link>
                      </li>
                      <li className="breadcrumb-item paragraph-small-fs9 font-color-1">
                        <Link
                          to={props.backTo}
                          className="breadcrumb-item paragraph-small-fs9 font-color-1"
                        >
                          {props.backToText || props.backTo}
                        </Link>
                      </li>
                      {props.title && (
                        <li className="breadcrumb-item paragraph-small-fs9 font-color-1 active">
                          {props.title}
                        </li>
                      )}
                    </>
                  ) : isBackPages ? (
                    <>
                      <li className="breadcrumb-item paragraph-small-fs9 font-color-1">
                        <Link
                          to={props.backTo}
                          className="breadcrumb-item paragraph-small-fs9 font-color-1"
                        >
                          {props.backToText || props.backTo}
                        </Link>
                      </li>
                      {props.title && (
                        <li className="breadcrumb-item paragraph-small-fs9 font-color-1 active">
                          {props.title}
                        </li>
                      )}
                    </>
                  ) : (
                    <>
                      <li className="breadcrumb-item paragraph-small-fs9 font-color-1">
                        <Link
                          to={props.backTo}
                        >
                          {props.backToText || props.backTo}
                        </Link>
                      </li>
                      {props.title && (
                        <li className="breadcrumb-item paragraph-small-fs9 font-color-1 active">
                          {props.title}
                        </li>
                      )}
                    </>
                  )}
                </ol>
              </nav>
            </section>
          ) : null }
          <HelpModal
            content={
              props.block && props.blockText ? props.blockText : props.helpText
            }
            isOpen={helpPopupVisible || props.showPopup}
            iconeShow={props.iconeShow}
            block={props.block}
            backToText={props.blockButton || props.backToText}
            backTo={props.backTo}
            parentClosesModal={props.parentClosesModal}
            removeTagDescriptionP={removeTagDescriptionP}
            helpPopupVisibleHandle={helpPopupVisibleHandle}
          />
          <div
            className="hero-container container"
            style={props.short ? { height: 200 } : {}}
          >
            <div className="hero__content d-flex flex-column">
              <div
                className={
                  !props.backTo
                    ? "container d-flex flex-direction-row align-items-center justify-content-center"
                    : "container"
                }
              >
                {!props.short && (
                  <>
                    <h1 className="hero-banner--title headline-bold-fs1 font-color-1">
                      <span>{props.title}</span>
                      {(props.helpText || props.iconeShow) && (
                        <i
                          className="info-icon gc-icon-functional-attention-2-col"
                          tabIndex="0"
                          role="button"
                          aria-label={t("common.additional.info")}
                          onClick={() => setHelpPopupVisible(true)}
                          onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  setHelpPopupVisible(true);
                              }
                          }}
                        >
                          <i className="path1" />
                          <i className="path2" />
                        </i>
                      )}
                    </h1>
                    {props.description && (
                      <h2 className="hero-banner--description headline-fs6 d-flex font-color-1">
                        {props.description}
                      </h2>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>) : (
        <div className="hero-container">
          <div className="d-flex flex-direction-row align-items-center justify-content-center">
            <div className="text-center text-container d-flex flex-column">
              <h1 className="headline-bold-fs2 font-color-1">{props.title}</h1>
              <h2 className="paragraph-large-fs7 font-color-1">{props.description}</h2>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default Hero;

const HelpModal = ({
  content,
  isOpen,
  iconeShow,
  block = false,
  backToText,
  parentClosesModal,
  helpPopupVisibleHandle,
  removeTagDescriptionP,
  backTo,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const helpPopupVisibleHandleChildren = () => {
    helpPopupVisibleHandle();
  };

  if (isOpen) {
    if (iconeShow) {
      return (
        <InfoModal
          helpPopupVisibleHandleChildren={helpPopupVisibleHandleChildren}
        />
      );
    } else {
      return (
        <Modal
          show={isOpen}
          onClose={() => {
            if (block) {
              history.goBack();
            }
            if (typeof helpPopupVisibleHandle === "function") {
              helpPopupVisibleHandle();
            }
            if (typeof parentClosesModal === "function") {
              parentClosesModal();
            }
          }}
          removeTagDescriptionP={removeTagDescriptionP}
          description= {content}
          type={"button"}
          linkTitle={block ? backToText : t("common.hoCapito")}
          onFirstClick={() => {
           if (block) {
             history.push(backTo);
           }
           if (typeof helpPopupVisibleHandle === "function") {
             helpPopupVisibleHandle();
           }
           if (typeof parentClosesModal === "function") {
             parentClosesModal();
           }
         }}
        />
      )
    }
  } else {
    return null;
  }
};

const InfoModal = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      content={
        <div className="active-section paragraph-main-fs8">
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part1")}
          </span>
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part2")}
          </span>
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part3")}
          </span>
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part4")}
          </span>
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part5")}
          </span>
          <span className="sp-text-block">
            {t("contract.tutelaPerdite.part6")}
          </span>
        </div>
      }
      show={true}
      onClose={props.helpPopupVisibleHandleChildren}
      onFirstClick={props.helpPopupVisibleHandleChildren}
      type="button"
      linkTitle={t("common.hoCapito")}
    />
  );
};
